// import axios from 'axios'
import api from '../utils/api'

export const getCEP = (cep) => api.get(process.env.VUE_APP_CEP_API + '?cep=' + cep)